import { createResource } from '../utils/resource'

const assetTypeStore = createResource('assettype', {})

export default assetTypeStore
